export { getCurrentUrl };
import { normalizeClientSideUrl } from './normalizeClientSideUrl.js';
import '../assertEnvClient.js';
function getCurrentUrl(options) {
    return normalizeClientSideUrl(window.location.href, options);
}
